/* BD 24.09.2026 v1. Alt: inline hero controller. Neu: immediate deferred controller for the dedicated variant section. Grund: server order, responsive first image preserved, existing variant/form sync retained. */
/* BeamDeals machine variant selection: Shopify variants are the only source of combinations and prices. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready === 'true') return;
    var data;
    try { data = JSON.parse(root.querySelector('[data-bd-variant-data]').textContent); } catch (error) { return; }
    if (!data.variants || !data.variants.length) return;
    var hero = document.querySelector('[data-bd-machine-hero]');
    if (!hero) return;
    var variants = data.variants;
    var current = variants.find(function (v) { return String(v.id) === root.dataset.initialVariant; }) || variants[0];
    var radios = Array.from(root.querySelectorAll('input[data-bd-option]'));
    var configs = Array.from(document.querySelectorAll('.bdcfg #bdVariant'));
    var syncing = false;
    var initialDisplay = true;
    function matching(index, value) {
      return variants.filter(function (v) {
        return v.options[index] === value && v.options.every(function (part, i) { return i >= index || part === current.options[i]; });
      });
    }
    function field(form, name, value) {
      var el = form.querySelector('input[name="' + name + '"]');
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = name; form.appendChild(el); }
      el.value = value || '';
    }
    function syncForms() {
      document.querySelectorAll('#bd21-machine-lead-form, form[data-bd-callback-contact]').forEach(function (form) {
        field(form, 'contact[Variante]', current.title);
        field(form, 'contact[Varianten-ID]', String(current.id));
        field(form, 'contact[Artikelnummer]', current.sku);
      });
    }
    function display(updateUrl, changedSelect) {
      radios.forEach(function (input) {
        var i = Number(input.dataset.bdOption);
        input.checked = input.value === current.options[i];
        input.disabled = matching(i, input.value).length === 0;
        var label = input.closest('label');
        label.classList.toggle('is-unavailable', input.disabled);
        var hint = label.querySelector('[data-bd-variant-compatibility]');
        if (hint) hint.textContent = input.disabled ? 'Andere ' + data.optionNames[0] + ' wählen' : '';
      });
      root.querySelector('[data-bd-selected-title]').textContent = current.title;
      root.querySelector('[data-bd-selected-price]').textContent = current.priceText;
      root.querySelector('[data-bd-selected-stock]').textContent = current.stockText;
      // Preserve the server-rendered minimum until a variant is explicitly selected.
      if (!initialDisplay || new URLSearchParams(location.search).has('variant')) {
        hero.querySelectorAll('[data-bd-machine-price]').forEach(function (el) { el.textContent = current.priceText; });
        hero.querySelectorAll('[data-bd-machine-price-label]').forEach(function (el) { el.textContent = 'Ihre Ausführung'; });
      }
      var changeImage = !initialDisplay;
      initialDisplay = false;
      var image = hero.querySelector('.bd21-product-image img');
      if (changeImage && image && current.image) {
        image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = current.image;
      }
      syncing = true;
      configs.forEach(function (select) {
        var index = Array.from(select.options).findIndex(function (opt) {
          return opt.dataset.variantId ? opt.dataset.variantId === String(current.id) : opt.dataset.title === current.title;
        });
        if (index >= 0) { select.selectedIndex = index; if (select !== changedSelect) select.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      syncing = false;
      syncForms();
      if (updateUrl) {
        try { var url = new URL(location.href); url.searchParams.set('variant', String(current.id)); history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (error) {}
      }
    }
    root.addEventListener('change', function (event) {
      var input = event.target.closest('input[data-bd-option]');
      if (!input || input.disabled) return;
      var index = Number(input.dataset.bdOption);
      var choices = matching(index, input.value);
      if (!choices.length) return;
      // Preserve the other choices wherever the new combination really exists.
      current = choices.reduce(function (best, item) {
        function score(v) { return v.options.reduce(function (n, part, i) { return n + (part === current.options[i] ? 1 : 0); }, 0); }
        return score(item) > score(best) ? item : best;
      }, choices[0]);
      display(true);
    });
    configs.forEach(function (select) {
      select.addEventListener('change', function () {
        if (syncing) return;
        var opt = select.options[select.selectedIndex];
        var next = variants.find(function (v) { return opt.dataset.variantId ? String(v.id) === opt.dataset.variantId : v.title === opt.dataset.title; });
        if (next) { current = next; display(true, select); }
      });
    });
    // Fields move with the existing callback form when its dialog opens.
    // Capture prepares only variant metadata before existing submission handlers.
    document.addEventListener('submit', function (event) {
      if (event.target.matches('#bd21-machine-lead-form, form[data-bd-callback-contact]')) syncForms();
    }, true);
    document.addEventListener('reset', function (event) {
      if (event.target.matches('#bd21-machine-lead-form, form[data-bd-callback-contact]')) setTimeout(syncForms, 0);
    });
    window.addEventListener('popstate', function () {
      var id = new URLSearchParams(location.search).get('variant');
      var next = variants.find(function (v) { return String(v.id) === id; });
      if (next) { current = next; display(false); }
    });
    root.dataset.ready = 'true';
    display(false);
  }
  function boot() { document.querySelectorAll('[data-bd-variant-picker]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

